import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDetails } from '../../models/userDetails';
import axios from 'axios';
import { getToken, getUserDetails } from '../../utilities/sessionHelper';

interface UserState {
  data: {
    createdBy: null | string;
    createdDate: null | string;
    lastModifiedBy: null | string;
    lastModifiedDate: null | string;
    id: string;
    email: string;
    name: string;
    businessUnit: string;
    department: string;
    reportingManagerName: string;
    reportingManagerEmail: string;
    employeeStatus: string;
    accessStatus: null | string;
  }|null;
  loading: boolean;
  requestResponse:{
    createdBy: string;
    createdDate: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    id: number;
    type: string;
    employeeName: string;
    employeeEmail: string;
    employeeId: string;
    businessUnit: string;
    department: string;
    reportingManagerName: string;
    reportingManagerEmail: string;
    role: string;
    accessReason: string;
    reminderEmailCount: number;
    requestStatus: string;
    approvalRejects: any[];
  } | null;
  availableRoles:any[] | null;
  error: string | null;
}

const initialState: UserState = {
  data: null,
  requestResponse:null,
  availableRoles:null,
  loading: false,
  error: null,
}; 

export const fetchSuccessFactorData:any = createAsyncThunk(
  'user/fetchSuccessFactorUserData',
  async (_,{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true
      };
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`user/fetchEmpDetailsSF`,axiosConfig);
      console.log('user/fetchEmpDetailsSF',response);
      if (response.data.status!=="OK") {
        const errorData = await response.data.error
        return rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAvailableRoles:any = createAsyncThunk(
  'user/fetchavailableRoles',
  async (_,{ rejectWithValue }) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true
      };
      const response = await axios.get(`user/roles/`,axiosConfig);
      console.log('user/roles',response);
      if (response.data.status!=="OK") {
        const errorData = await response.data.error
        return rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const sendNewAccessRequest:any = createAsyncThunk(
    'user/sendNewAccessRequest',
    async (values:any,{ rejectWithValue }) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email
          },
          withCredentials: true
        };
        // Simulate an API call, replace with your actual API request
        const response = await axios.post(`user/request/raiseNewAccessRequest`,values,axiosConfig);
        console.log('user/request/raiseNewAccessRequest',response);
        if (response.data.status!=="OK") {
          const errorData = await response.data.error
          return rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

const successFactorUserSlice:any = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSuccessFactorUserData: (state, action: PayloadAction<UserState['data']>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchSuccessFactorUserRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccessFactorUserSuccess: (state, action: PayloadAction<UserState['data']>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchSuccessFactorUserFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    // fetchNewRequestResponseSucces: (state, action: PayloadAction<UserState['requestResponse']>) => {
    //     state.requestResponse = action.payload;
    //     state.loading = false;
    //     state.error = null;
    //   }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuccessFactorData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSuccessFactorData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchSuccessFactorData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchAvailableRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAvailableRoles.fulfilled, (state, action) => {
        state.availableRoles = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchAvailableRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(sendNewAccessRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendNewAccessRequest.fulfilled, (state, action) => {
        state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(sendNewAccessRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export const { setSuccessFactorUserData, fetchSuccessFactorUserRequest, fetchSuccessFactorUserSuccess, fetchSuccessFactorUserFailure } = successFactorUserSlice.actions;

export default successFactorUserSlice.reducer;